import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import AllProjects from "../components/projects/allProjects";

import { useLanguage } from "../i18n/LanguageContext";

import "./styles/projects.css";

const Projects = () => {
	const { t, messages } = useLanguage();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const seo = messages.seo.projects;

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${t("titles.projects")} | ${t("main.siteTitle")}`}</title>
				<meta name="description" content={seo.description} />
				<meta name="keywords" content={seo.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-container">
						<div className="title projects-title">
							{messages.projectsPage.title}
						</div>

						<div className="subtitle projects-subtitle">
							{messages.projectsPage.subtitle}
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
